import { defineStore } from "pinia";

export const useDeptPoStore = defineStore('DeptPo', {
    state:()=>({
        data:null,
        // hiddenData:null,
    }),
    actions:{
        setData(value){
            this.data = value; 
            sessionStorage.setItem('po', value);
        },
        loadData(){
            this.data = sessionStorage.getItem('po');
        },
        // setHidden(value){
        //     this.hiddenData = value;
        //     sessionStorage.setItem('hiddenParam', value);
        // },
        // loadHidden(){
        //     this.hiddenData = sessionStorage.getItem('hiddenParam');
        // }
    }
})